import { ICheckoutPickupStoresOptions } from '@commerce-checkout-webcomponents/sdk';
import { CartRoutePaths } from '@commerce-cart-webcomponents/sdk';
import { RoutePaths } from '@commerce-profile-webcomponents/sdk';
import { ISoftFilters } from '../../checkout-shipping-details/types/propTypes';
import { IBackHeaderConfig } from '../../checkout-events-modal/types/propTypes';

export enum ShippingTypeEnums {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

export enum DataTypesEnums {
  TYPE_STRING = 'TYPE_STRING',
  TYPE_NUMBER = 'TYPE_NUMBER',
}

export const errorImageUrl = '/images/CheckoutPageError.svg';
export const noStoreErrorImageUrl = '/images/checkoutNoStoreError.svg';
export const orderReceivedImage = '/images/CheckoutOrderReceived.svg';

export const loaderCardArray = [0, 1, 2, 3];
export const pickupDrawerLoaderArray = [0, 1, 2];

const paymentLoaderTiles = {
  height: '24',
  paddingTop: '12px',
  paddingBottom: '12px',
  paddingLeft: '16px',
  paddingRight: '16px',
  border: '1px solid #E4E4E4',
  borderRadius: '12px',
  marginBottom: '8px',
};
const commonLoaderContainer = {
  paddingTop: '0px',
  paddingBottom: '0',
};

const paymentSubtiles = [
  {
    ...paymentLoaderTiles,
    id: '2',
  },
  {
    ...paymentLoaderTiles,
    id: '3',
  },
  {
    ...paymentLoaderTiles,
    id: '4',
  },
  {
    ...paymentLoaderTiles,
    id: '5',
  },
];

const commonTileL1 = { id: '2', height: '24', paddingTop: '0', paddingBottom: '8px' };
const commonTileL2 = { id: '3', height: '24', paddingTop: '8px', paddingBottom: '20px' };
const commonTileL3 = { id: '1', height: '24', paddingTop: '32px', paddingBottom: '16px' };
const commonTileL4 = { id: '2', height: '16', paddingTop: '0', paddingBottom: '6px' };
const commonTileL5 = { id: '4', height: '16', paddingTop: '6px', paddingBottom: '32px' };

export const loaderSkeletonConfig = [
  {
    ...commonLoaderContainer,
    id: 'shipping-details',
    skeltonFrames: [{ id: '1', height: '40', paddingTop: '12px', paddingBottom: '16px' }, commonTileL1, commonTileL2],
    mobileSkeltonFrames: [
      commonTileL3,
      commonTileL4,
      { id: '3', height: '16', paddingTop: '6px', paddingBottom: '6px' },
      commonTileL5,
    ],
  },
  {
    ...commonLoaderContainer,
    id: 'delivery-options',
    skeltonFrames: [{ id: '1', height: '40', paddingTop: '32px', paddingBottom: '16px' }, commonTileL1, commonTileL2],
    mobileSkeltonFrames: [commonTileL3, commonTileL4, commonTileL5],
  },
  {
    ...commonLoaderContainer,
    paddingBottom: '40px',
    mobileOnlyPadding: {
      paddingBottom: '32px',
    },
    id: 'payment-details',
    skeltonFrames: [{ id: '1', height: '40', paddingTop: '32px', paddingBottom: '16px' }, ...paymentSubtiles],
    mobileSkeltonFrames: [commonTileL3, ...paymentSubtiles],
  },
];

export enum LoaderTypeEnums {
  PICKUP_DRAWER = 'PICKUP_DRAWER',
  STORE_LIST = 'STORE_LIST',
  FULL_PAGE = 'FULL_PAGE',
}

export const storeFieldForSearch = ['addressLine', 'name', 'id', 'region'];

export const countryDropdownLabelField = 'callingCode';

export const LocalStorageKeys = {
  CHECKOUT_ID: 'checkoutId',
  CHECKOUT_VERSION: 'checkoutVersion',
  CHECKOUT_PROFILE: 'checkoutProfile',
  CART_ID: 'cartId',
  CART_OBJ: 'CartObj',
  WAREHOUSE_ID: 'warehouseId',
  SHARECODE_ATTRIBUTES: 'sharecodeAttributes',
};

export const checkoutShippingDetailsActions = {
  SET_SHIPPING_DETAILS_DATA: 'SET_SHIPPING_DETAILS_DATA',
  SET_DISPLAY_ADD_NEW_ADDRESS_FOR_DELIVERY: 'SET_DISPLAY_ADD_NEW_ADDRESS_FOR_DELIVERY',
  SET_DISPLAY_ADD_NEW_ADDRESS_FOR_PICKUP: 'SET_DISPLAY_ADD_NEW_ADDRESS_FOR_PICKUP',
  SET_DISPLAY_CONFIRMED_ADDRESS: 'SET_DISPLAY_CONFIRMED_ADDRESS',
  SET_DISPLAY_ADDRESS_SELECTION: 'SET_DISPLAY_ADDRESS_SELECTION',
  SET_DISPLAY_ADDRESS_BOOK: 'SET_DISPLAY_ADDRESS_BOOK',
  IS_DELIVERY_ADDRESS_AVAILABLE: 'IS_DELIVERY_ADDRESS_AVAILABLE',
  IS_PICKUP_ADDRESS_AVAILABLE: 'IS_PICKUP_ADDRESS_AVAILABLE',
  SHIPPING_ADDRESS: 'SHIPPING_ADDRESS',
  STORE_PICKUP_ADDRESS: 'STORE_PICKUP_ADDRESS',
  SET_SHIPPING_TYPE: 'SET_SHIPPING_TYPE',
  SET_STORE_OPTIONS_DATA: 'SET_STORE_OPTIONS_DATA',
  SET_STORE_DETAILS_DRAWER_VISIBILITY: 'SET_STORE_DETAILS_DRAWER_VISIBILITY',
  SET_STORE_DETAILS_DATA: 'SET_STORE_DETAILS_DATA',
  SET_SELECTED_STORE_ID: 'SET_SELECTED_STORE_ID',
  SET_SELECTED_SERVICE_LOCATION: 'SET_SELECTED_SERVICE_LOCATION',
  SET_RECIPIENT_CONTACT: 'SET_RECIPIENT_CONTACT',
  SET_RECIPIENT_COUNTRY_CODE: 'SET_RECIPIENT_COUNTRY_CODE',
  SET_STORE_PIN: 'SET_STORE_PIN',
  SET_STORE_TYPE_OPTIONS: 'SET_STORE_TYPE_OPTIONS',
  SET_STORE_MAP: 'SET_STORE_MAP',
  SET_STORE_OPTION_NAME: 'SET_STORE_OPTION_NAME',
  SET_PICKUP_DRAWER_LOADING: 'SET_PICKUP_DRAWER_LOADING',
  // SET_PICKUP_CONTACT_DRAWER_VISIBILITY: 'SET_PICKUP_CONTACT_DRAWER_VISIBILITY',
  SET_SOFT_FILTERS: 'SET_SOFT_FILTERS',
  SET_ENABLE_LOCATION_CTA_VISIBILITY: 'SET_ENABLE_LOCATION_CTA_VISIBILITY',
  SET_LOCATION_PERMISSION: 'SET_LOCATION_PERMISSION',
  SET_IS_ADDRESS_SAVED_FLAG: 'SET_IS_ADDRESS_SAVED_FLAG',
  SET_RECIPIENT_NAME: 'SET_RECIPIENT_NAME',
  SET_RECIPIENT_EMAIL: 'SET_RECIPIENT_EMAIL',
  SET_FULFILLMENT_TYPE_FOR_PICKUP: 'SET_FULFILLMENT_TYPE_FOR_PICKUP',
  SET_SHIPPING_DETAILS_UPDATING: 'SET_SHIPPING_DETAILS_UPDATING',
};

export const shippingOptions = [
  {
    type: ShippingTypeEnums.DELIVERY,
    label: 'checkout.CheckoutShippingType.radioLabelDelivery',
    icon: 'truck',
    id: '1',
  },
  {
    type: ShippingTypeEnums.PICKUP,
    label: 'checkout.CheckoutShippingType.radioLabelPickup',
    icon: 'location-dot',
    id: '2',
  },
];

export const softFilterObject: ISoftFilters = {
  delivery: { message: '', isVisible: false },
  pickup: { message: '', isVisible: false },
};

export const storeDetailsData: ICheckoutPickupStoresOptions = {
  name: '',
  addressLine: '',
  id: '',
  contact: '',
  schedule: {},
};

export const dayLabels = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export enum LocationPermission {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
}

export const geoLocation = 'geolocation';

export const checkoutShippingOptions = {
  HOMEDELIVERY: 'homedelivery',
  BOPIS: 'bopis',
};

export const checkoutPostalCodeLength5 = 5;
export const checkoutPostalCodeLength6 = 6;

export const amwayStorePaginationLimit = 100;
export const edpStorePaginationLimit = 2000;
export const fulfillmentStorePaginationLimit = 20;

export const headerBackConfig: IBackHeaderConfig = {
  registration: {
    title: 'checkout.CheckoutEventsModal.registrationTitle',
    desc: 'checkout.CheckoutEventsModal.registrationDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.registrationPrimaryButtonTitle',
    primaryButtonRedirection: true,
    secondaryButtonLabel: 'checkout.CheckoutEventsModal.registrationSecondaryButtonTitle',
  },
  renewal: {
    title: 'checkout.CheckoutEventsModal.renewalTitle',
    desc: 'checkout.CheckoutEventsModal.renewalDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.renewalPrimaryButtonTitle',
    secondaryButtonLabel: 'checkout.CheckoutEventsModal.renewalSecondaryButtonTitle',
    secondaryButtonRedirection: true,
  },
  upgrade: {
    title: 'checkout.CheckoutEventsModal.upgradeTitle',
    desc: 'checkout.CheckoutEventsModal.upgradeDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.upgradePrimaryButtonTitle',
    secondaryButtonLabel: 'checkout.CheckoutEventsModal.upgradeSecondaryButtonTitle',
    secondaryButtonRedirection: true,
  },
  downgrade: {
    title: 'checkout.CheckoutEventsModal.downgradeTitle',
    desc: 'checkout.CheckoutEventsModal.downgradeDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.downgradePrimaryButtonTitle',
    secondaryButtonLabel: 'checkout.CheckoutEventsModal.downgradeSecondaryButtonTitle',
    secondaryButtonRedirection: true,
  },
  default: {
    title: 'checkout.CheckoutEventsModal.leaveCheckoutConfirmationModalTitle',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.continueCheckout',
    secondaryButtonLabel: 'checkout.CheckoutEventsModal.backToCart',
    secondaryButtonRedirection: true,
  },
};
export const errorModalConfig: IBackHeaderConfig = {
  'comregistrationas-account-already-exists': {
    title: 'checkout.CheckoutEventsModal.alreadyRegisteredTitle',
    desc: 'checkout.CheckoutEventsModal.alreadyRegisteredDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.alreadyRegisteredPrimaryButtonLabel',
    primaryButtonRedirection: true,
    redirectUrl: CartRoutePaths.CART,
  },
  'comregistrationas-account-already-renewed': {
    title: 'checkout.CheckoutEventsModal.alreadyRenewedTitle',
    desc: 'checkout.CheckoutEventsModal.alreadyRenewedDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.alreadyRenewedPrimaryButtonLabel',
    primaryButtonRedirection: true,
    redirectUrl: CartRoutePaths.CART,
  },
  'comregistrationas-account-already-upgraded': {
    title: 'checkout.CheckoutEventsModal.alreadyUpgradedTitle',
    desc: 'checkout.CheckoutEventsModal.alreadyUpgradedDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.alreadyUpgradedPrimaryButtonLabel',
    primaryButtonRedirection: true,
  },
  'comregistrationas-account-already-downgraded': {
    title: 'checkout.CheckoutEventsModal.alreadyDowngradedTitle',
    desc: 'checkout.CheckoutEventsModal.alreadyDowngradedDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.alreadyDowngradedPrimaryButtonLabel',
    primaryButtonRedirection: true,
  },
  'comregistrationas-account-lifecycle-change-blocked': {
    title: 'checkout.CheckoutEventsModal.accountLifeCycleBlockedTitle',
    desc: 'checkout.CheckoutEventsModal.accountLifeCycleBlockedDescription',
    primaryButtonLabel: 'checkout.CheckoutEventsModal.accountLifeCycleBlockedPrimaryButtonTitle',
    primaryButtonRedirection: true,
    addAccountProcessType: true,
  },
};

export const errorCardConfig: IBackHeaderConfig = {
  'comregistrationas-submit-validation-error': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    desc: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongDesc',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-unknown-error': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-blacklist-error': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    desc: 'checkout.CheckoutErrorCardConfig.registration.blackListDesc',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-account-already-exists': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    desc: 'checkout.CheckoutErrorCardConfig.registration.accountAlreadyExistDesc',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrations-cooling-period-error': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    desc: 'checkout.CheckoutErrorCardConfig.registration.coolingPeriodDesc',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-account-exists': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    desc: 'checkout.CheckoutErrorCardConfig.registration.accountExistDesc',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  'comregistrationas-internal-server-error': {
    title: 'checkout.CheckoutErrorCardConfig.registration.someThingWentWrongTitle',
    primaryButtonLabel: 'checkout.CheckoutErrorCardConfig.registration.goToHomePageButton',
    redirectUrl: RoutePaths.HOME,
  },
  default: {
    title: 'checkout.CheckoutUILayout.errorTitle',
    desc: 'checkout.CheckoutUILayout.errorDescription',
    primaryButtonLabel: 'checkout.CheckoutUILayout.backToCartCTA',
    redirectUrl: CartRoutePaths.CART,
  },
};

export const OrderConfirmation = '/order/';
